var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content-container"},[_c('el-breadcrumb',{attrs:{"separator":"/"}},[_c('el-breadcrumb-item',{attrs:{"to":{ path: '/dashboard' }}},[_vm._v("首页")]),_c('el-breadcrumb-item',[_vm._v("客户联系人")])],1),_c('UserList')],1)}
var staticRenderFns = []

export { render, staticRenderFns }